export const AGR = {
  tenant: "AGR",
  name: "Fieragricola 2022",
  default_language: 'it',
  languages: ["it", "en"], //, "fr", "zh", "ru", "ko", "ja", "pt", "es", "de"
  enable_login: true,
  enable_helpdesk: false,
  enable_favorites: true,
  enable_suggested: false,
  enable_halls: true,
  enable_chat: false,
  enable_bcards: false,
  enable_memos: false,
  enable_wizard: false,
  enable_agenda: false,
  enable_terms: true,
  enable_complaints: false,
  enable_languages_in_menu: true,
  tracking: [
    {
      //   type: 'hotjar',
      //   code: 183316,
      //   domains: ['catalogo.fieragricola.it']
      // }, {
      // type: 'analytics',
      // code: 'UA-1767479-4', //fiera produzione
      // domains: ['fieragricola.it'],
      // }, {
      //   type: 'analytics',
      //   code: 'UA-169833767-1', //interno test
      //   domains: ['recat-agr-test.firebaseapp.com'],
      // }, {
      //   type: 'analytics',
      //   code: 'UA-169833767-2', //interno produzione
      //   domains: ['catalogo.fieragricola.it'],
    }
  ],
  share_networks: ["facebook", "twitter", "pinterest"],
  translations: {
    // url: "https://ozwol-tech-cdn.s3-eu-west-1.amazonaws.com/veronafiere/fieragricola/",
    url: `${window.location.origin}/assets/locales/fieragricola/`
  },
  ozwol: {
    endpoint: "https://api.ozwol.cloud/v1/executeScript",
    apiKey: "f9dc3e58-acc9-466f-9af1-085a19f86015",
    projectId: "47S3WM8K6G",
    cdn: "https://cdn.ozwol.cloud/47S3WM8K6G"
  },
  sendmail: {
    endpoint: "https://us-central1-vrf-fieragricola-app.cloudfunctions.net/app/api/sendmail",
    email: "noreply@veronafiere.it",
    complaints_email: "noreply@veronafiere.it",
    // bcc: "sara.potyscki@ozwol.com" //separati da virgola
  },
  cookiebot: null, // "fa032822-e5b2-4f06-9239-e13dcd2e3d89",
  auth0: {
    domain: "login.veronafiere.it",
    clientID: "5fcloXhq0Bim67ia4N9CSAJR1DtcU8hb",
    responseType: "token id_token",
    scope: 'openid profile email',
    audience: "https://veronafiere.api.it",
    issuer: 'https://login.veronafiere.it/',
  },
  bcards: {
    apiUrl: null //"https://vrf-vinitaly-app.appspot.com/user/bcards/"
  },
  memos: {
    apiUrl: "https://vrf-firegricola-app.appspot.com/user/memos/"
  },
  news: {
    apiUrl: "https://apicatalogo.veronafiere.it/v1/AGR/contenuti_plus/"
  },
  recommended: {
    apiUrl: "https://apicatalogo.veronafiere.it/v1/AGR/users/"
  },
  areas: {
    "companies": {
      icon: 'company.svg',
      dataServiceKey: "exhibitors",
      enable: true,
      enable_detail: true,
      default: true,
      routes: {
        list: 'companies',
        detail: 'companies/{slug}'
      },
      subareas: {
        "companies": {
          default: true,
          key: "company",
          dataServiceKey: "",
          enable: true,
          enable_detail: true
        }
      }
    },
    "products": {
      icon: 'product.svg',
      dataServiceKey: "products",
      enable: true,
      enable_detail: true,
      default: false,
      singlePermission: "productdetail:r",
      routes: {
        list: 'products/{type}',
        detail: 'products/{type}/{slug}'
      },
      subareas: {
        "products": {
          default: true,
          key: "products",
          dataServiceKey: "",
          enable: true,
          enable_detail: true
        }
      }
    },
    "casehistories": {
      icon: 'casehistory.svg',
      dataServiceKey: "projects",
      enable: false,
      default: false,
      singlePermission: "projectdetail:r",
      routes: {
        list: 'casehistories',
        detail: 'casehistories/{slug}'
      },
      subareas: {
        "casehistories": {
          default: true,
          key: "casehistories",
          dataServiceKey: "",
          enable: true,
          enable_detail: true
        }
      }
    },
    "events": {
      icon: 'event.svg',
      dataServiceKey: "events",
      enable: false,
      enable_detail: true,
      default: false,
      routes: {
        list: 'events/{type}',
        detail: 'events/{type}/{slug}'
      },
      subareas: {
        "indoor": {
          default: true,
          key: "indoor",
          dataServiceKey: "indoor",
          enable: true,
          enable_detail: true
        },
        "outdoor": {
          default: false,
          key: "outdoor",
          dataServiceKey: "outdoor",
          enable: true,
          enable_detail: false
        }
      }
    }
  },
  accountSettings: {
    theme: "fieragricola",
    proAccount: false
  },
  chatConfig: {
    default: {
      pluginEnv: 'staging',
      wsEndpoint: 'wss://qh2k5m2qw1.execute-api.eu-west-1.amazonaws.com/test/',
      apiUrl: 'https://11o2teju4f.execute-api.eu-west-1.amazonaws.com/staging/agr/',
      favoritesUrl: 'https://deevent-api-dev.24apps.it/api/v2/userdata/public/favorites',
      recentsUrl: 'https://deevent-api-dev.24apps.it/api/v2/userdata/public/recents',
      accountUrl: 'https://deevent-api-dev.24apps.it/api/v2/account/public'
    },
    'fieragricola.8preview.it': {
      pluginEnv: 'staging',
      wsEndpoint: 'wss://qh2k5m2qw1.execute-api.eu-west-1.amazonaws.com/test/',
      apiUrl: 'https://11o2teju4f.execute-api.eu-west-1.amazonaws.com/staging/agr/',
      favoritesUrl: 'https://deevent-api-dev.24apps.it/api/v2/userdata/public/favorites',
      recentsUrl: 'https://deevent-api-dev.24apps.it/api/v2/userdata/public/recents',
      accountUrl: 'https://deevent-api-dev.24apps.it/api/v2/account/public'
    },
    'catalogo.fieragricola.it': {
      pluginEnv: 'production',
      wsEndpoint: 'wss://chat.quickchat.online/vrf/',
      apiUrl: 'https://l1iq9e6hm6.execute-api.eu-west-1.amazonaws.com/production/agr/',
      favoritesUrl: 'https://deevent-api.24apps.it/api/v2/userdata/public/favorites',
      recentsUrl: 'https://deevent-api.24apps.it/api/v2/userdata/public/recents',
      accountUrl: 'https://deevent-api.24apps.it/api/v2/account/public'
    }
  },
  awsAnalytics: {
    localhost: null,
    default: {
      area: "staging",
      credentials: {
        accessKeyId: "",
        secretAccessKey: ""
      },
      region: "eu-west-1",
      deliveryStreamName: "testCatalogoWebFirehoseDelivery"
    },
    'catalogo.fieragricola.it': {
      area: "production",
      credentials: {
        accessKeyId: "",
        secretAccessKey: ""
      },
      region: "eu-west-1",
      deliveryStreamName: "AGRCatalogoWebFirehoseDeliveryStream"
    },
    'fieragricola.it': {
      area: "production",
      credentials: {
        accessKeyId: "",
        secretAccessKey: ""
      },
      region: "eu-west-1",
      deliveryStreamName: "AGRCatalogoWebFirehoseDeliveryStream"
    }
  },
  "needPermissionTo": []
};
